
import { contacts } from '@/store/case'
import { isLoadingEndpoint } from 'mega-composable'
import { computed, defineComponent } from 'vue'
import { isEmpty } from 'lodash-es'

export default defineComponent({
  setup() {
    const isLoading = isLoadingEndpoint('request/contacts')

    const secondaryContacts = computed(() => contacts.value?.otherPolygonContacts || [])
    const projectManager = computed(() => contacts.value?.projectManager)
    const hasSecondaryContacts = computed(() => !isEmpty(secondaryContacts.value))

    return {
      isLoading,
      secondaryContacts,
      projectManager,
      hasSecondaryContacts
    }
  }
})

